import { IMetadataDataPoint } from "./IMetadataDataPoint";

export function pointsKeys(points: IMetadataDataPoint[]): string[] {
    const used = new Set<string>();
    return points.map(({ deviceId, time }) => {
        let key = `${deviceId}-${time.getTime()}`;
        while (used.has(key)) {
            key += ".";
        }
        used.add(key);
        return key;
    });
}
